import React from 'react';
import AnalisiCommercialeGo from './AnalisiCommercialeGo';

/**
 * Vendita - clienti: dati di vendita letti dal gestionale GO.
 *
 * Le autofatture di integrazione IVA (reverse charge, acquisti intra ed extra
 * UE) stanno nella vista ricavi ma **non sono ricavi**: sono la contropartita
 * di acquisti. Sono 611 righe per 1.406.478 € e in certi mesi pesano molto —
 * ad agosto 2026, 7 righe su 14. Escluse di default, con l'interruttore in
 * chiaro e la loro quota sempre esposta quando le si include.
 *
 * Fatturato e ordinato non si sommano mai: si sovrappongono, perche' quasi
 * tutto l'ordinato risulta gia' fatturato. Per questo sono due viste
 * alternative nella stessa tendina, non due colonne affiancate.
 */

export default function VenditaClientiGoPage() {
  return (
    <AnalisiCommercialeGo
      ciclo="attivo"
      titolo="Vendita - clienti"
      introduzione={
        'Fatturato letto da Gestionale Open, aggregato per cliente. Le autofatture di ' +
        'integrazione IVA sono escluse di default: stanno nella stessa vista ma sono ' +
        'la contropartita di acquisti, non ricavi. Fatturato e ordinato non si sommano ' +
        'fra loro — quasi tutto l\'ordinato risulta già fatturato.'
      }
    />
  );
}
